import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { LOGIN } from '../thunks/login/reduers'
import { checkLogin } from '../utils'
import { checkUserAuth } from '../utils/authUtils'
// import './styles.css'

const ProtectedRoutes = () => {
  const dispatch = useDispatch()
  const { loggedIn } = useSelector((state) => state.login)
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    const checkAuth = async () => {
      if (checkLogin()) {
        dispatch({ type: LOGIN.LOGGED_IN })
        
        // Check if token is valid by calling /me API
        try {
          const isValid = await checkUserAuth();
          setIsAuthenticated(isValid);
          
          if (!isValid) {
            // Token is invalid, clear it
            localStorage.removeItem('authToken');
            dispatch({ type: LOGIN.LOGGED_OUT })
          }
        } catch (error) {
          console.error('Auth check failed:', error);
          localStorage.removeItem('authToken');
          dispatch({ type: LOGIN.LOGGED_OUT })
        }
      }
      setIsCheckingAuth(false);
    };

    checkAuth();
  }, [dispatch])

  if (isCheckingAuth) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!loggedIn || !isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

export default ProtectedRoutes
